<template>
  <div class="character">
    <div class="character__image">
      <img :src="form.url" :alt="form.name">
    </div>
    <div class="character__form">
      <form class="form">
        <div class="form__group">
          <text-input label="Name" v-model="form.name" :required="true" />
        </div>
        <div class="form__group">
          <number-input label="First Seen" v-model="form.firstSeen" :required="true" />
        </div>
        <div class="form__group">
          <select-input label="Type" v-model="form.type" :options="typeOptions" />
        </div>
        <div class="form__group">
          <textarea-input label="Bio" v-model="form.bio" />
        </div>
        <div class="form__submit">
          <button :disabled="disabled || !formIsValid" @click.prevent="submit">
            Save
          </button>
          <button
            v-if="id"
            @click.prevent="remove"
            class="is-light"
            :disabled="disabled"
          >
            Delete
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import TextInput from '@/components/TextInput.vue';
import TextareaInput from '@/components/TextareaInput.vue';
import NumberInput from '@/components/NumberInput.vue';
import SelectInput from '@/components/SelectInput.vue';

export default {
  name: 'CharacterForm',
  components: {
    TextInput,
    TextareaInput,
    NumberInput,
    SelectInput,
  },
  props: {
    id: String,
    name: String,
    type: String,
    firstSeen: Number,
    url: String,
    disabled: Boolean,
    bio: String,
  },
  watch: {
    $route() {
      this.setForm();
    },
  },
  data() {
    return {
      form: {},
      typeOptions: ['Main', 'Supporting'],
    };
  },
  computed: {
    formIsValid() {
      return this.form.name && this.form.firstSeen;
    },
  },
  created() {
    this.setForm();
  },
  methods: {
    setForm() {
      const { $props } = this;
      this.form = {
        url: $props.url,
        name: $props.name,
        firstSeen: $props.firstSeen,
        type: $props.type || 'Main',
        bio: $props.bio || '',
      };
    },
    submit() {
      const formValue = { ...this.form };
      formValue.firstSeen = parseInt(formValue.firstSeen, 10);
      this.$emit('submit', formValue);
    },
    remove() {
      this.$emit('remove');
    },
  },
};
</script>

<style lang="scss" scoped>
.character {
  width: 700px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  @media all and (max-width: 700px) {
    padding: 20px;
    display: block;
  }
  &__image {
    width: 340px;
    margin: 0 50px 0 0;
    img {
      max-width: 100%;
    }
    @media all and (max-width: 700px) {
      width: 100%;
    }
  }
  &__form {
    flex: 1;
  }
}

.form {
  &__group {
    margin-bottom: 10px;
  }
  &__submit {
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
  }
}
</style>
